import { CaretDownOutlined, FunnelPlotOutlined } from '@ant-design/icons';
import Pagination from '@material-ui/lab/Pagination';
import { Badge, Button, Checkbox, DatePicker, Form, Input, Modal, Row, Select, Space } from 'antd';
import _ from 'lodash';
import moment from "moment";
import React, { Suspense, useEffect, useState } from "react";
import {
    //  FormattedMessage, 
    injectIntl
} from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import ActionEditDelete from '../../../components/ActionEditDelete';
import CustomButton from '../../../components/CustomButton';
import {
    actionGetAllbank,
    actionGetListDepositUSDT,
} from '../../../redux/transaction/actions';
import { useSubheader } from "../../../_metronic/layout";
import {
    Card,
    CardBody
} from "../../../_metronic/_partials/controls";
import {
    _convertHash,
    formatCoin,
    formatCoinID,
    formatMoney
} from '../../lib/common';
import CreateUpdateWithdrawUSDT from './CreateUpdateWithdrawUSDT';
import { HISTORY_CHANGE_COIN_TYPE } from '../../../const';
const { RangePicker } = DatePicker;

const formRef = React.createRef()

function ListDepositUSDT(props) {
    const suhbeader = useSubheader();

    const [visibleSearch, setVisibleSearch] = useState(false)
    const [visible, setVisible] = useState(false);
    //const [visibleModal, setVisibleModal] = useState(false);
    const [checkbox, setCheckbox] = useState([]);
    const [visibleModalDetail, setVisibleModalDetail] = useState(false)
    const [recordModal, setRecordModal] = useState(null)
    const [filterModal, setFilterModal] = useState(null)
    const [date, setDate] = useState([null, null])
    const [date_active, setDateActive] = useState([null, null])
    const { intl } = props
    suhbeader.setTitle(intl.formatMessage({ id: 'SIDEBAR.LIST_DEPOSIT_USDT' }));
    const dispatch = useDispatch();
    const { dataDepositUSDT, dataAllBank } = useSelector(state => ({
        dataDepositUSDT: state.transactionReducer.dataDepositUSDT,
        dataAllBank: state.transactionReducer.dataAllBank
    }), shallowEqual)
    console.log(dataDepositUSDT)
    useEffect(() => {
        dispatch(actionGetListDepositUSDT({ page: 1, type: HISTORY_CHANGE_COIN_TYPE.DEPOSIT }));
        dispatch(actionGetAllbank())
    }, [dispatch])

    const onChangePage = async (_, page) => {
        let { user_name, transactionID, email, mobile, bank, type, chain, status, tx_hash, vip, type_user } = formRef.current.getFieldsValue()
        let filter = {
        }
        if (email)
            filter.email = email.trim()
        if (mobile)
            filter.mobile = mobile.trim()
        if (type)
            filter.type = type.trim()
        if (bank)
            filter.bank = bank.trim()
        if (chain)
            filter.chain = chain.trim()
        if (vip) {
            filter.vip = vip
        }
        if (status) {
            filter.status = status
        }
        if (tx_hash) {
            filter.tx_hash = tx_hash.trim()
        }
        if (type_user) {
            filter.type_user = type_user
        }
        if (date && date.length > 0 && date[0]) {
            filter.date = [moment(date[0]).format('YYYY/MM/DD'), moment(date[1]).format('YYYY/MM/DD')]
        }
        // if (date[0] && date[1])
        //     filter.date = JSON.stringify([moment(date[0]).format('YYYY/MM/DD'), moment(date[1]).format('YYYY/MM/DD')])
        setFilterModal({ ...filter, ...filterModal })
        await dispatch(actionGetListDepositUSDT(
            {
                ...filter,
                page, user_name: user_name ? user_name.trim() : '',
                transactionID: transactionID ? transactionID.trim() : '', type: HISTORY_CHANGE_COIN_TYPE.DEPOSIT
            }
        ));
    }

    const onSearchDelayed = _.debounce(() => onSearch(), 100)
    const onSearch = async () => {
        let { user_name, transactionID, email, mobile, bank, type, chain, status, tx_hash, vip, type_user } = formRef.current.getFieldsValue()
        setVisibleSearch(true)
        const object_search = { page: 1 }
        if (user_name)
            object_search.name = user_name.trim()
        if (transactionID)
            object_search.transactionID = transactionID.trim()
        if (bank)
            object_search.bank = bank.trim()
        if (checkbox.length > 0)
            object_search.status = JSON.stringify(checkbox)
        if (date && date.length > 0 && date[0]) {
            object_search.date = [moment(date[0]).format('YYYY/MM/DD'), moment(date[1]).format('YYYY/MM/DD')]
        }
        if (email) 
            object_search.email = email.trim()
        if (mobile)
            object_search.mobile = mobile.trim()
        if (type)
            object_search.type = type.trim()
        if (chain) {
            object_search.chain = chain.trim()
        }
        if (status) {
            object_search.status = status
        }
        if (tx_hash) {
            object_search.tx_hash = tx_hash.trim()
        }
        if (vip) {
            object_search.vip = vip
        }
        if (type_user !== '') {
            object_search.type_user = type_user
        }
        setFilterModal({ ...filterModal, ...object_search })
        await dispatch(actionGetListDepositUSDT({...object_search, type: HISTORY_CHANGE_COIN_TYPE.DEPOSIT}));
        setVisible(false)
    }

    const onChangeDateRange = async (e) => {
        let { user_name_source, email_source, mobile_source, user_name_destination, transactionID, email, mobile, type, start, end, start_usd, end_usd, start_money, end_money, type_user, vip } = formRef.current.getFieldsValue()
        let data_filter = {}
        if (type) {
            data_filter.type = type
        }
        if (start) {
            data_filter.start = start
        }
        if (start_usd) {
            data_filter.start_usd = start_usd
        }
        if (end_usd) {
            data_filter.end_usd = end_usd
        }
        if (start_money) {
            data_filter.start_money = start_money
        }
        if (end_money) {
            data_filter.end_money = end_money
        }
        if (end) {
            data_filter.end = end
        }
        if (email)
            data_filter.email = email.trim()
        if (mobile)
            data_filter.mobile = mobile.trim()
        if (email_source)
            data_filter.email_source = email_source.trim()
        if (mobile_source)
            data_filter.mobile_source = mobile_source.trim()
        if (type_user)
            data_filter.type_user = type_user
        if (vip)
            data_filter.vip = vip
        if (e && e.length > 1) {
            let dataReq = await dispatch(actionGetListDepositUSDT({ date: [moment(e[0]).format('YYYY/MM/DD'), moment(e[1]).format('YYYY/MM/DD')], page: 1, type: HISTORY_CHANGE_COIN_TYPE.DEPOSIT, user_name_source: user_name_source ? user_name_source.trim() : '', transactionID: transactionID ? transactionID.trim() : '', user_name_destination: user_name_destination ? user_name_destination.trim() : '', ...data_filter }));
            // setTotalMoneyBuy(dataReq.sumMoneyBuy)
            // setTotalMoneySell(dataReq.sumMoneySell)
            // setTotalUSDBuy(dataReq.sumUSDBuy)
            // setTotalUSDSell(dataReq.sumUSDSell)
            setDate(e)
        }
        else {
            let dataReq = await dispatch(actionGetListDepositUSDT({ page: 1, type: HISTORY_CHANGE_COIN_TYPE.DEPOSIT, user_name_source: user_name_source ? user_name_source.trim() : '', transactionID: transactionID ? transactionID.trim() : '', user_name_destination: user_name_destination ? user_name_destination.trim() : '', ...data_filter }));
            // setTotalMoneyBuy(dataReq.sumMoneyBuy)
            // setTotalMoneySell(dataReq.sumMoneySell)
            // setTotalUSDBuy(dataReq.sumUSDBuy)
            // setTotalUSDSell(dataReq.sumUSDSell)
        }
    };

    const onExportDelayed = async () => {

        const url = new URL(`${process.env.REACT_APP_API_URL}/admin/exportExcel/list-deposit-usdt`);
        const accessToken = localStorage.getItem('token');
        url.searchParams.append("token", accessToken);
        let { user_name, transactionID, email, mobile, bank, type, chain, status, tx_hash, vip, type_user } = formRef.current.getFieldsValue()
        setVisibleSearch(true)
        const object_search = {}
        if (user_name)
            object_search.name = user_name.trim()
        if (tx_hash)
            object_search.tx_hash = tx_hash.trim()
        if (bank)
            object_search.bank = bank.trim()
        if (transactionID)
            object_search.transactionID = transactionID.trim()
        if (checkbox.length > 0)
            object_search.status = JSON.stringify(checkbox)
        if (date[0] && date[1])
            object_search.date = JSON.stringify([moment(date[0]).format('YYYY/MM/DD'), moment(date[1]).format('YYYY/MM/DD')])
        if (date_active[0] && date_active[1])
            object_search.date_active = JSON.stringify([moment(date_active[0]).format('YYYY/MM/DD'), moment(date_active[1]).format('YYYY/MM/DD')])

        if (email)
            object_search.email = email.trim()
        if (mobile)
            object_search.mobile = mobile.trim()
        if (type)
            object_search.type = type.trim()
        if (vip) {
            object_search.vip = vip
        }
        if (status) {
            object_search.status = status
        }
        if (type_user) {
            object_search.type_user = type_user
        }
        if (chain) {
            object_search.chain = chain.trim()
        }
        Object.keys(object_search).forEach(key => {
            url.searchParams.append(key, object_search[key]);
        });
        window.open(url);
        // setVisibleSearch(false)
        // onClearSearch()
    }

    const renderStatus = (record) => {
        let status = record.status;
        if (status == 0 && record.pending_epay) {
            status = 3;
        }
        switch (status) {
            case 0: {
                return (
                    <Badge status="warning" text='Chờ' />
                )
            }
            case 1: {
                return (
                    <Badge status="processing" text='Thành công' />
                )
            }
            case 2: {
                return (
                    <Badge status="processing" text='Đang xử lý' />
                )
            }
            
            case -1: {
                return (
                    <Badge status="error" text='Ngừng giao dịch' />
                )
            }
            default:
                break;
        }
    }
    const closeDetail = () => {
        setRecordModal(null)
        setFilterModal(null)
        setVisibleModalDetail(false)
    }

    const renderViewTransactionWeb = (network,hash)=>{
        switch(network){
            case 'polygon' :{
                return `https://polygonscan.com/tx/${hash}`
            }
            case 'ton' :{
                return `https://tonviewer.com/transaction/${hash}`
            }
            case 'tron' :{
                return `https://tronscan.org/#/transaction/${hash}`
            }
            case 'bsc' :{
                return `https://bscscan.com/tx/${hash}`
            }
            case 'onus_chain':
                // return `https://explorer.onuschain.io/tx/${hash}/internal-transactions`
                return `https://explorer.onuschain.io/tx/${hash}/token-transfers`
            default : {
                return `${hash}`
            }
        }
    }
    const closeModal = async () => {
        setCheckbox([])
        setVisible(false)
    }
    const renderAgency = (level) => {
        switch (level) {
          case 1:
            return "Đại sứ kinh doanh";
          case 2:
            return "Nhượng quyền trực tuyến";
        }
        return "Người dùng";
    };
    const renderNameChain = (network) => {
        switch(network) {
            case 'ton':
                return 'TON'
            case 'tron':
                return 'Tron'
            case 'polygon':
                return 'Polygon'
            case 'bsc':
                return 'BSC'
        }
    }
    const renderBodyTable = () => {
        return dataDepositUSDT?.rows?.length > 0
            ? dataDepositUSDT?.rows?.map((it, idx) => {
                return (
                    <tr key={`renderBodyTable_${it.id || idx}`}>
                        <td className="tr-center">
                            {(dataDepositUSDT?.paging?.page - 1) * dataDepositUSDT?.paging?.limit + idx + 1}
                        </td>
                        <td className="tr-center maxw--200">
                            {it?.transaction_id}
                        </td>
                        <td className="tr-left maxw--200">
                            {it?.user?.fullname}<br />{it?.user?.email}<br />{it?.user?.mobile}
                        </td>
                        <td className="tr-center maxw--200">
                            {it?.user?.level}
                        </td>
                        <td className="tr-center maxw--200">
                            {renderAgency(it?.user?.agency?.level) || "--"}
                        </td>
                        <td className="tr-center maxw--200">
                            {renderNameChain(it?.network)}
                        </td>
                        <td className="tr-center maxw--200">
                            <a href={renderViewTransactionWeb(it?.network,it?.tx_hash)} target='_blank'>{_convertHash(it?.tx_hash)}</a>
                        </td>
                        <td className="tr-center maxw--200">
                            {formatCoin(Math.abs(Number(it?.transaction?.amount_coin)),4)}
                        </td>
                        <td className="tr-center maxw--200">
                            {formatCoin(it?.transaction?.fee, 4)}
                        </td>
                        <td className="tr-center maxw--200">
                            {moment(it?.createdAt).format('DD/MM/YYYY HH:mm:ss')}
                        </td>
                        <td className="tr-center maxw--200">
                            {renderStatus(it)}
                        </td>
                    </tr>
                )
            })
            : <tr>
                <td className="tr-center" colSpan={12}>Không có dữ liệu hiển thị</td>
            </tr>
    }

    const onClearSearch = async () => {
        formRef.current.setFieldsValue({ user_name: undefined, transactionID: undefined, email: undefined, mobile: undefined, bank: undefined, type: '', chain: '', type_user: "", vip: undefined, tx_hash: "", picker: undefined })
        setCheckbox([])
        setDate([null, null])
        setVisibleSearch(false)
        await dispatch(actionGetListDepositUSDT({ page: 1, type: HISTORY_CHANGE_COIN_TYPE.DEPOSIT }));
    }


    function onChangeCheckbox(checkedValues) {
        let arr = [...checkbox]
        if (checkedValues.target.checked == true) {
            arr.push(checkedValues.target.value)
        }
        if (checkedValues.target.checked == false) {
            arr = checkbox.filter(it => it !== checkedValues.target.value)
        }

        setCheckbox(arr)
    }
    const enterKeyPressed = (event) => {
        if (event.keyCode == 13) {
            onSearch()
        }
    }
    return (
        <>
            <Card>
                {/* <CardHeader title={intl.formatMessage({ id: 'SIDEBAR.TRANSACTION.LIST_WITHDRAW_MONEY' })}>
                </CardHeader> */}
                <CardBody>
                    <Form
                        className="width100"
                        ref={formRef}
                    >
                        <div className="layout-form-header row">
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    Mã giao dịch{` `}
                                </div>
                                <Form.Item
                                    className="name"
                                    name="transactionID"
                                >
                                    <Input
                                        onKeyDown={enterKeyPressed}
                                        className="customInput width100"
                                        placeholder="Nhập mã giao dịch"
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    Khách hàng{` `}
                                </div>
                                <Form.Item
                                    className="name"
                                    name="user_name"
                                >
                                    <Input
                                        onKeyDown={enterKeyPressed}
                                        className="customInput width100"
                                        placeholder="Nhập tên khách hàng"
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    Email{` `}
                                </div>
                                <Form.Item
                                    className="email"
                                    name="email"
                                >
                                    <Input
                                        onKeyDown={enterKeyPressed}
                                        className="customInput width100"
                                        placeholder="Nhập email"
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    SĐT{` `}
                                </div>
                                <Form.Item
                                    className="mobile"
                                    name="mobile"
                                >
                                    <Input
                                        onKeyDown={enterKeyPressed}
                                        className="customInput width100"
                                        placeholder="Nhập số điện thoại"
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    Tx Hash{` `}
                                </div>
                                <Form.Item
                                    className="mobile"
                                    name="tx_hash"
                                >
                                    <Input
                                        onKeyDown={enterKeyPressed}
                                        className="customInput width100"
                                        placeholder="Nhập đường dẫn"
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">Hạng VIP {` `}</div>
                                <Form.Item className="name" name="vip">
                                    <Select
                                        placeholder="Chọn hạng VIP"
                                        // defaultValue={""}
                                        className="trongCustomSelect2"
                                        mode="multiple"
                                    >
                                        {/* <Select.Option value={""}>Tất cả</Select.Option> */}
                                        <Select.Option value={"0"}>Cấp 0</Select.Option>
                                        <Select.Option value={"1"}>Cấp 1</Select.Option>
                                        <Select.Option value={"2"}>Cấp 2</Select.Option>
                                        <Select.Option value={"3"}>Cấp 3</Select.Option>
                                        <Select.Option value={"4"}>Cấp 4</Select.Option>
                                        <Select.Option value={"5"}>Cấp 5</Select.Option>
                                        <Select.Option value={"6"}>Cấp 6</Select.Option>
                                        <Select.Option value={"7"}>Cấp 7</Select.Option>
                                    </Select>
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">Nhóm người dùng{` `}</div>
                                <Form.Item className="name" name="type_user">
                                    <Select
                                        placeholder="Chọn nhóm người dùng"
                                        className="customSelect"
                                        suffixIcon={<CaretDownOutlined />}
                                        defaultValue={""}
                                    >   
                                        <Select.Option value={""}>Tất cả</Select.Option>
                                        <Select.Option value={0}>Người dùng</Select.Option>
                                        <Select.Option value={1}>Đại sứ kinh doanh</Select.Option>
                                        <Select.Option value={2}>Nhượng quyền trực tuyến</Select.Option>
                                    </Select>
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    Mạng lưới{` `}
                                </div>
                                <Form.Item
                                    name="chain"
                                >
                                    <Select
                                        className="customSelect"
                                        suffixIcon={<CaretDownOutlined />}
                                        placeholder="Chọn trạng thái"
                                        defaultValue={''}
                                        onChange={onSearchDelayed}
                                    >
                                        <Select.Option value={''}>Tất cả</Select.Option>
                                        <Select.Option value={'bsc'}>BSC</Select.Option>
                                        <Select.Option value={'polygon'}>Polygon</Select.Option>
                                        {/* <Select.Option value={'tron'}>Tron</Select.Option> */}
                                        <Select.Option value={'ton'}>TON</Select.Option>
                                    </Select>
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    Trạng thái{` `}
                                </div>
                                <Form.Item
                                    name="status"
                                >
                                    <Select
                                        className="customSelect"
                                        suffixIcon={<CaretDownOutlined />}
                                        placeholder="Chọn trạng thái"
                                        defaultValue={''}
                                        onChange={onSearchDelayed}
                                    >
                                        <Select.Option value={''}>Tất cả</Select.Option>
                                        <Select.Option value={'0'}>Chờ</Select.Option>
                                        <Select.Option value={'1'}>Thành công</Select.Option>
                                        <Select.Option value={'-1'}>Ngừng giao dịch</Select.Option>
                                        {/* <Select.Option value={'2'}>ton</Select.Option> */}
                                    </Select>
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">Thời gian giao dịch{` `}</div>
                                <Space className="customSpace">
                                    <Form.Item name="picker">
                                        <RangePicker
                                        allowClear
                                        onChange={(e) => onChangeDateRange(e)}
                                        placeholder={["Từ ngày", "Đến ngày"]}
                                        className="customDate"
                                        />
                                    </Form.Item>
                                </Space>
                            </div>
                        </div>

                        <div className="mb--20 row-end">
                            <CustomButton
                                className="mr--10"
                                title="Tìm kiếm"
                                btnBgColor="#3699ff"
                                btnColor="#ffffff"
                                btnHoverBackground="#187de4"
                                onClick={onSearchDelayed}
                            />
                            {visibleSearch && <CustomButton
                                className="customClearSearch mr--10"
                                title="Bỏ lọc"
                                btnBgColor="#eceef7"
                                btnColor="#192038"
                                btnHoverBackground="#eceef7"
                                onClick={onClearSearch}
                            />}
                            <CustomButton
                                className="mr--10"
                                title="Xuất file"
                                btnBgColor="#838d20"
                                btnColor="#ffffff"
                                btnHoverBackground="#187de4"
                                onClick={onExportDelayed}
                            />
                        </div>
                       {/*  <div className="d-flex space-between col-12">
                            <div className=""><span className="b--700">Tổng số:{' '}</span>{formatMoney(dataDepositUSDT?.total || 0)}</div>
                            <div className=""><span className="b--700">Tổng phí:{' '}</span>{formatCoinID(dataDepositUSDT?.sumFee, 4)}</div>
                            <div className=""><span className="b--700">Tổng tiền:{' '}</span>{formatCoinID(dataDepositUSDT?.sumMoney, 4)}</div>
                            <div className=""><span className="b--700"></span></div>
                        </div> */}
                        <div className="trongCustomTableCtn2">
                            <table className="customTable">
                                <tr className="bg-E6F8FD">
                                    <th className="tr-center">STT</th>
                                    <th className="tr-center">Mã giao dịch</th>
                                    <th className="tr-center">Khách hàng</th>
                                    <th className="tr-center">Hạng VIP</th>
                                    <th className="tr-center">Nhóm người dùng</th>
                                    <th className="tr-center">Mạng</th>
                                    <th className="tr-center">Tx Hash</th>
                                    <th className="tr-center">Số tiền (USDT)</th>
                                    <th className="tr-center">Phí giao dịch (USDT)</th> 
                                    <th className="tr-center">Thời gian giao dịch</th>
                                    {/* <th className="tr-center">Thời gian duyệt</th> */}
                                    <th className="tr-center">Trạng thái</th>
                                    {/* <th className="tr-center">Thao tác</th> */}
                                </tr>
                                {renderBodyTable()}
                            </table>
                        </div>
                        <div className="mt--20 rowx-center">
                            {dataDepositUSDT?.paging?.total > dataDepositUSDT?.paging?.limit && <div className="mt--20 rowx-center">
                                <Pagination
                                    count={dataDepositUSDT?.paging?.count} //total
                                    page={dataDepositUSDT?.paging?.page} //current page
                                    variant="outlined" shape="rounded" showFirstButton showLastButton
                                    onChange={(event, page) => onChangePage(event, page)}
                                />
                            </div>}
                        </div>
                    </Form>
                </CardBody>
            </Card>
            <Modal
                title="Lọc"
                centered
                visible={visible}
                onCancel={() => setVisible(false)}
                width={'20%'}
                footer={(
                    <div className="row-end">
                        <CustomButton
                            className="customClearSearch border-none mr--10"
                            title="Thoát"
                            btnBgColor="#ff708d"
                            btnColor="#ffffff"
                            btnHoverBackground="#ff708d"
                            onClick={closeModal}
                        />
                        <CustomButton
                            title="Áp dụng"
                            btnBgColor="#3699ff"
                            btnColor="#ffffff"
                            btnHoverBackground="#187de4"
                            //onClick={() => setVisible(false), onSearchDelayed}
                            onClick={onSearchDelayed}
                        />
                    </div>
                )}
            >
                <Row>
                    <Checkbox value={-1} checked={checkbox.includes(-1) === true ? true : false} onChange={onChangeCheckbox}><Badge status="error" text='Ngừng giao dịch' /></Checkbox>
                </Row>
                <Row>
                    <Checkbox value={0} checked={checkbox.includes(0) === true ? true : false} onChange={onChangeCheckbox}><Badge status="warning" text='Chờ' /></Checkbox>
                </Row>
                {/* <Row>
                    <Checkbox value={1} checked={checkbox.includes(2) === true ? true : false} onChange={onChangeCheckbox}><Badge status="processing" text='Đang giao dịch' /></Checkbox>
                </Row> */}
                <Row>
                    <Checkbox value={2} checked={checkbox.includes(1) === true ? true : false} onChange={onChangeCheckbox}><Badge status="success" text='Hoàn thành' /></Checkbox>
                </Row>
            </Modal>
            <Suspense fallback={<div></div>}>
                <section>
                    {visibleModalDetail && <CreateUpdateWithdrawUSDT
                        onCloseModal={closeDetail}
                        visibleModal={visibleModalDetail}
                        recordModal={recordModal}
                        setRecordModal={setRecordModal}
                        filterModal={filterModal}
                    />}
                </section>
            </Suspense>
        </>
    );
};
export default injectIntl(withRouter(ListDepositUSDT));